<template>
  <div
    class="section-recommendation-tile rounded-2 min-w-[180px] max-w-[250px] p-2 cursor-pointer select-none"
    :class="{ 'section-recommendation-tile--selected': !!modelValue }"
    @click="$emit('update:modelValue', !modelValue)"
  >
    <CImage
      :ai-img-description="recommendation.name"
      class="rounded-2 overflow-hidden"
      height="135"
      lazy
      object-fit="cover"
      preview-disabled
      :src="recommendation?.metadata?.thumbnail || recommendation?.thumbnail_url"
      width="240"
    />
    <div class="text-truncate font-bold font-size-4">
      {{ recommendation.name }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { type CanvasRetrieve } from '@openapi'
import useThemeVars from '@lib/composables/useThemeVars'
import CImage from '@lib/components/CImage/CImage.vue'

defineEmits<{
  (e: 'update:modelValue', v: boolean): void
}>()

defineProps<{
  recommendation: CanvasRetrieve
  modelValue: boolean
}>()

const themeVars = useThemeVars()
</script>

<style scoped lang="scss">
.section-recommendation-tile {
  background: v-bind('themeVars.base');

  &--selected {
    background: v-bind('themeVars.primary4');
  }
}
</style>
